import React from 'react';
import moment from 'moment';
import Slider from 'react-slick';
import Icon from '../graphics/Icon';
import styled from 'styled-components';

const Alerts = styled.div`
  background: #F26859;
  max-width: 70%;
  padding: 0 20px;
  margin: 0 auto 20px auto;

  .slick-track {
    height: auto !important;
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    flex-direction: column;
  }
`;
const Alert = styled.div`
  color: #fff;
  height: 110px;
  display: flex !important;
  align-items: center;

  .text {
    line-height: 1em;
  }
  .arrow {
    margin-left: 15px;
    cursor: pointer;
    float: right;

    &:hover g g {
      fill: #FEDB97;
    }
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
  p {
    display: inline;
  }
`;

function goToLocation(item) {
  if (item.url) {
    window.open(item.url, '_blank');
  } else {
    
  }
}

const mobileNews = (props) => {
  // const { results, news } = props;
  // console.log(props.news);
  var alerts = [], today = moment();
  if (props.news && props.news.length > 0) {
    props.news.map(newsItem => {
      var a = {};
      var dateTo = new Date(newsItem.dateTo);
      var dateFrom = new Date(newsItem.dateFrom);
      if (moment(today).isBetween(dateFrom, dateTo)) {
        a = { ...newsItem };
        a.headline = newsItem.title ? newsItem.title : 'News:';
        a.message = newsItem.content;
        alerts.push(a);
      }
    });
  }
  props.results.map(result => {
    if (result.currentAlerts.length > 0) {
      for (let alert of result.currentAlerts) {
        var a = {};
        a = { ...result };
        a.headline = (result.name1 && result.name2) ? result.name1 + ' - ' + result.name2 : result.title;
        a.message = alert.Comments;
        alerts.push(a);
      }
    }
  });
  if (alerts.length > 1) {
    const settings = {
      autoplay: true,
      dots: false,
      arrows: false,
      centerPadding: 0,
      infinite: true,
      speed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true
    };
    var alertText = alerts.map((alert, i) => {
      return (
        <Alert key={i}>
          <div className="text"><b>{alert.headline}</b> <span dangerouslySetInnerHTML={{ __html: alert.message }}></span></div>  
          <div className="arrow" onClick={() => goToLocation(alert)}><Icon name="next" /></div>
        </Alert>
      );
    });
    return (
      <Alerts>
        <Slider {...settings}>
          {alertText}
        </Slider>
      </Alerts>
    );
  } else if (alerts.length === 1) {
    return (
      <Alerts>
        <Alert>
          <div className="text"><b>{alert.headline}</b> 
            <span dangerouslySetInnerHTML={{ __html: alerts[0].message }}></span>
          </div>
          <div className="arrow" onClick={() => goToLocation(alerts[0])}><Icon name="next" /></div>
        </Alert>
      </Alerts>
    );
  } else {
    return null;
  }
}

export default mobileNews;


// WEBPACK FOOTER //
// ./src/components/static/MobileNews.js